import React from "react"

import { ProjectChild } from "shared/types/Project"

import { DeleteProjectChildrenOverlayView } from "./DeleteProjectChildrenOverlayView"
import { useDeleteProjectChildrenOverlayModel } from "./hooks/useDeleteProjectChildrenOverlayModel"

export interface DeleteProjectChildrenOverlayPayload {
  projectID: string
  childrenToDelete: ProjectChild[]
}

export interface DeleteProjectChildrenOverlayProps {
  payload: DeleteProjectChildrenOverlayPayload
}

export const DeleteProjectChildrenOverlay = React.memo(
  (props: DeleteProjectChildrenOverlayProps) => (
    <DeleteProjectChildrenOverlayView
      {...useDeleteProjectChildrenOverlayModel(props)}
    />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    DELETE_PROJECT_CHILDREN_OVERLAY: DeleteProjectChildrenOverlayPayload
  }
}
